import React, { useEffect, useState } from 'react';
import AddButton from 'components/v2/buttons/AddButton';
import Card from 'components/v2/card/Card';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
import SearchField from 'components/v2/SearchField';
import { useWarehousesWithAssociation } from 'hooks/warehouse/useManageWarehouse';
import LoadingIndicator from 'components/v2/LoadingIndicator';
import SessionStore from 'stores/SessionStore';
import AddWarehouseForm from './AddWarehouse';
import WarehouseListItem from './WarehouseListItem';
const ManageWarehouse = () => {
    const { t } = useTranslation();
    const [showAddWarehouseForm, setShowAddWarehouseForm] = useState(false);
    const [query, setQuery] = useState('');
    const [warehouseData, setWarehouseData] = useState([]);
    const [queryData, setQueryData] = useState([]);
    const { data = [], isLoading } = useWarehousesWithAssociation();
    const canPerformActions = SessionStore.hasShipperOnboardingRole();
    const populateData = (inputWarehouseData = {}) => {
        if (!Object.keys(inputWarehouseData).length) {
            return;
        }
        const { location, shippers: shippersData, _id, active, } = inputWarehouseData;
        const address = location === null || location === void 0 ? void 0 : location.address;
        const warehouse_location = location === null || location === void 0 ? void 0 : location._id;
        const shippers = shippersData.map(({ shipper, relations }) => {
            return Object.assign(Object.assign({}, shipper), { isFromApi: true, warehouseUsers: relations.map(({ warehouse_user, active, status, _id: relation_id }) => (Object.assign(Object.assign({}, warehouse_user), { relation_id, isFromApi: true, active,
                    status }))) });
        });
        return {
            address,
            warehouse_location,
            shippers,
            _id,
            active,
            isFromApi: true,
        };
    };
    useEffect(() => {
        if (data === null || data === void 0 ? void 0 : data.length) {
            setWarehouseData(data.map((d) => populateData(d)));
        }
    }, [data]);
    useEffect(() => {
        if (query.length >= 2) {
            const searchData = warehouseData.filter((warehouse) => warehouse.address.toLowerCase().includes(query.toLowerCase().trim()));
            setQueryData(searchData);
        }
        else {
            setQueryData([]);
        }
    }, [query]);
    const breadcrumbs = {
        pages: [
            {
                name: t('WAREHOUSE'),
                href: `/manage/warehouse`,
                current: true,
            },
        ],
    };
    function renderHeading() {
        return (React.createElement("div", { "data-testid": "manage-warehouse-title", className: "mb-4 flex items-center space-x-4" },
            React.createElement("h3", { className: "" }, t('WAREHOUSE', { count: 2 })),
            canPerformActions && (React.createElement(AddButton, { size: "medium", onClick: () => setShowAddWarehouseForm(true) }))));
    }
    const renderAddWarehouseForm = () => {
        if (!showAddWarehouseForm) {
            return null;
        }
        return (React.createElement(AddWarehouseForm, { data: {}, onCancel: () => setShowAddWarehouseForm(false) }));
    };
    const showEmptyWarehouseMessage = () => (React.createElement("p", { "data-testid": "manage-warehouse-empty-message" }, t('EMPTY_WAREHOUSE_MSG')));
    const renderWarehouseList = (data = []) => {
        if (!data.length) {
            return showEmptyWarehouseMessage();
        }
        return data.map((warehouse, i) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(WarehouseListItem, { data: warehouse, key: i, actionsEnabled: canPerformActions }),
                i !== data.length - 1 && React.createElement("hr", { className: "m-0" })));
        });
    };
    const renderWarehouses = () => {
        if (isLoading) {
            return React.createElement(LoadingIndicator, null);
        }
        if (!(warehouseData === null || warehouseData === void 0 ? void 0 : warehouseData.length)) {
            return showEmptyWarehouseMessage();
        }
        const showSearchData = query && query.length >= 2;
        return (React.createElement(Card, { className: "mb-14" },
            showSearchData &&
                (queryData.length > 0
                    ? renderWarehouseList(queryData)
                    : showEmptyWarehouseMessage()),
            !showSearchData && renderWarehouseList(warehouseData)));
    };
    return (React.createElement(LayoutWithSidebar, { className: "mt-4 p-0", breadcrumbs: breadcrumbs },
        React.createElement("div", { "data-testid": "manage-warehouse-page", className: "lx:w-1/2 w-full" },
            renderHeading(),
            React.createElement("div", { "data-testid": "manage-warehouse-address-search", className: "mt-4 mb-2" },
                React.createElement(SearchField, { placeholder: t('SEARCH_LOCATION_EXISTING'), value: query, onChange: (val) => setQuery(val) })),
            renderAddWarehouseForm(),
            renderWarehouses())));
};
export default ManageWarehouse;
